document.addEventListener("DOMContentLoaded", function () {
  //
  //
  let lastScrollTop = 0;

  let finalTop = 0;

  // if (window.innerWidth > 767) {
  //   window.addEventListener("scroll", function () {
  //     // let windowHeight = window.innerHeight;

  //     // const filterContainer = document.querySelector(".facets");

  //     // //
  //     // //
  //     // let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  //     // let top = windowHeight - filterContainer.clientHeight;

  //     // let headerHeight = document.querySelector(
  //     //   ".section-header.shopify-section-group-header-group"
  //     // ).clientHeight;
  //     // let menuHeight = document.querySelector(
  //     //   ".section-header ~ .shopify-section-group-header-group"
  //     // ).clientHeight;

  //     // let navbarHeight = headerHeight + menuHeight;

  //     // if (scrollTop > lastScrollTop) {
  //     //   // down
  //     //   if (windowHeight < filterContainer.clientHeight + navbarHeight + 20) {
  //     //     finalTop = top - 20;
  //     //   } else {
  //     //     finalTop = navbarHeight + 20;
  //     //   }
  //     // } else {
  //     //   // up
  //     //   let scrollValue = Math.ceil(lastScrollTop - scrollTop);

  //     //   finalTop = finalTop + scrollValue + 20;

  //     //   if (finalTop > 0) {
  //     //     finalTop = navbarHeight + 20;
  //     //   }
  //     // }

  //     // lastScrollTop = scrollTop;

  //     //
  //     // filterContainer.style.top = `${finalTop}px`;
  //   });
  // }

  const mblFilterBtn = document.querySelector(".mbl-floating-filter-btn");
  const closeBtn = document.querySelector(".btn-close");
  const facet = document.querySelector(".facets");
  if (mblFilterBtn) {
    mblFilterBtn.addEventListener("click", function (e) {
      e.preventDefault();
      facet.classList.add("open");
      mblFilterBtn.classList.add('hide')
    });
  }

  if (closeBtn) {
    closeBtn.addEventListener("click", function (e) {
      e.preventDefault();
      facet.classList.remove("open");
      mblFilterBtn.classList.remove("hide");
    });
  }
  const perform_with_close = document.querySelector("#FacetsWrapperDesktop .btn-filter");
  if(perform_with_close){
    perform_with_close.addEventListener("click", function (e) {
      e.preventDefault();
      document.querySelector(".mbl-floating-filter-btn.hide")?.classList?.remove("hide");
    });
  }
});
